module.exports = __webpack_public_path__ + "img/safe04.05cbb9a0.png";